module.exports = __webpack_public_path__ + "img/gisbergen.877cf12d.svg";